import API_service from "../xAppLib/providers/API_service";

export default class evermed_model {
    med_dets = []
    del_opts = []

    static SEL_MED_DETS(prodVar) {
        return this.med_dets?.find(p => p.productVariantType === prodVar)
	}

    static SEL_DEL_DETS(code){
        return this.del_opts?.find(opt => code?.includes(opt.code))
    }

	static async getDeliveryAndMedOpts({mppAmtCode, pbsCode, postcode, qty}) {
		const payload = await API_service.load_data('evermed/deliveryAndMedOpts', {mppAmtCode, pbsCode, postcode, qty})
		if (payload.medPrices && payload.delOpts) {
            this.med_dets = payload.medPrices
            this.del_opts = payload.delOpts
            return payload
		}
		return Promise.reject(new Error(payload?.err || payload?.msg || 'Unknown error loading treatment plan'))
	}

    static async getMedPrices({mppAmtCode, pbsCode, qty}) {
		const payload = await API_service.load_data('evermed/getMedPrice', {mppAmtCode, pbsCode, qty})
		if (Array.isArray(payload) && payload.length > 0) {
            return payload
		}
		return Promise.reject(new Error(payload?.err || payload?.msg || 'Unknown error loading medication'))
	}

    static async getOrderStatus({orderNumber}){
        const res = await API_service.load_data(`evermed/getOrderStatus/${orderNumber}`)
        console.log({res})
        
        return res
    }

    static async cancelOrder({sid, orderNumber}){
        const res = await API_service.load_data(`evermed/cancelOrder`, {sid, orderNumber})
        return res
    }
}
